import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { HostListener } from '@angular/core';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
import { TranspaymentinfoComponent } from '../../grid/transpaymentinfo/transpaymentinfo.component';
import { ActivitypopupComponent } from '../../grid/activitypopup/activitypopup.component';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';

@Component({
  selector: 'app-addtraining',
  templateUrl: './addtraining.component.html',
  styleUrls: ['./addtraining.component.css']
})
export class AddtrainingComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "TRAINING";

  //Display
  formmode: string = "Add";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  ispaymentmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  ismanualclose: boolean;

  isemploading: boolean=false;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Edit Get Values
  trainingColl: any = [];
  trainingBO: any = {};

  trainingid: number = 0

  //bonustypeColl:any=[];
  empColl: any = [];
  empBO: any = {}

  trainingform = new FormGroup({
    trainingid: new FormControl(0),
    empid: new FormControl(null, Validators.required),
    // bonustypeid:new FormControl(null,Validators.required),  
    startdt: new FormControl(null, Validators.required),
    enddt: new FormControl(null, Validators.required),
    cost: new FormControl(0),
    title: new FormControl('', Validators.required),
    descr: new FormControl(''),
    //effectivedt:new FormControl('',Validators.required),  
    ispaidbyemployee: new FormControl(false),
    inactive: new FormControl(false),
  });

  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal,private confirmationDialogService: ConfirmationDialogService,
     private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.trainingid = params.id
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.trainingform.reset();
      this.fnInitializeFormGroup();

      if (this.trainingid > 0) {
        this.fngetTraining();
      }
      //this.fngetBonusType();
      this.fngetEmployee();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.trainingid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    this.ispaymentmode = this.loginService.fnCheckUserRoleAction(this.formname, 'PAYMENT')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  fnInitializeFormGroup() {
    this.trainingform.setValue({
      trainingid: 0,
      empid: null,
      startdt: new Date(),
      enddt: new Date(),
      cost: 0,
      title: '',
      descr: '',
      ispaidbyemployee: false,
      inactive: false
    })
  }

  // fngetBonusType() {   
  //   var data = {
  //       'bonusid':0,
  //       'companyid': this.loginService.fnGetCompanyId(),            
  //   }
  //   this.appService.getBonusType(data)
  //   .subscribe(
  //       (res)=>{                  
  //         if(res.json().status===200){
  //             this.bonustypeColl=res.json().result;                    
  //         }else {
  //             this.loginService.fnAPIError(res.json())
  //         }             
  //       },
  //       (err)=>{          
  //           this.toastr.error('Error', err);
  //   })
  // }


  fngetEmployee() {
    this.isemploading=true;
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.isemploading=false;
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnChangeEmpLookup();
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.isemploading=false;
          this.toastr.error('Error', err);
        })
  }


  //Get 
  fngetTraining() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'trainingid': this.trainingid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetTraining(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.fnHideProgress();

            this.trainingColl = res.json().result;
            var editdata = this.trainingColl[0];
            this.fnEditMode(editdata);
            this.trainingBO = editdata;
          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }

  fnChangeEmpLookup() {
    var empid = 0;

    empid = this.trainingform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {
        if (abo.empid === empid) {
          this.empBO = abo;
        }
      }

    }
    else {
      this.empBO = {};
    }
  }


  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.trainingform.get('enddt'))) {
        this.trainingform.controls['enddt'].setErrors(null);
      }


      //Validate
      if (this.trainingform.valid) {

        if (this.loginService.fnCompareDateValidation(this.trainingform.get('enddt').value, this.trainingform.get('startdt').value)) {
          this.trainingform.controls['enddt'].setErrors({ 'notfound': true });
          return
        }

        this.saveloading = true;

        //Check
        var data = {
          'trainingid': this.trainingid,
          'startdt': this.fnFormatDatetime(this.trainingform.get('startdt').value),
          'enddt': this.fnFormatDatetime(this.trainingform.get('enddt').value),
          'empid': this.trainingform.get('empid').value,
          'cost': this.trainingform.get('cost').value,
          'title': this.trainingform.get('title').value,
          'descr': this.trainingform.get('descr').value,
          'ispaidbyemployee': this.trainingform.get('ispaidbyemployee').value,
          'inactive': this.trainingform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.trainingform.get('trainingid').value > 0) {
          //Update 
          this.fnSetTraining(data);
        }
        else {
          //Insert 
          this.fnInsertTraining(data);
        }


      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertTraining(data) {

    this.appService.fnInsertTraining(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The new training has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
            var _result = res.json().result;
            if (_result.length > 0) {
              this.fnEditFormEdit(_result[0].trainingid);
            }
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTraining(data) {

    this.appService.fnSetTraining(data).subscribe(
      (res) => {
        this.saveloading = false;

        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.fnResetSaveFlag();
            this.toastr.success('', "The training has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.trainingid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.trainingid);
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;

        this.toastr.error('Error', err);
      });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }
  fnEditFormEdit(id) {

    this.trainingid = id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;


    let queryParams = {
      'id': id,
      'status': this.filterstatus,
      'empid': this.filteremployeeid,
      'empname': this.filteremployeename,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }



    this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
      this.ngOnInit();
    });
  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'empid': this.filteremployeeid,
          'empname': this.filteremployeename,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/Training'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
  private fnEditMode(deptBO) {
    deptBO.startdt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.startdt));
    deptBO.enddt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.enddt));

    this.trainingform.setValue({
      trainingid: deptBO.trainingid,
      empid: deptBO.empid,
      //bonustypeid:deptBO.bonustypeid,
      startdt: deptBO.startdt,
      descr: deptBO.descr,
      enddt: deptBO.enddt,
      cost: deptBO.cost,
      title: deptBO.title,
      ispaidbyemployee: deptBO.ispaidbyemployee,
      inactive: deptBO.inactive
    });

    this.formmode = "Edit";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;
    this.fnChangeEmpLookup();

    this.fnGetAttachmentCount();
  }


  fnAddPaymentInfo() {

    const modalRef = this.productFindService.open(TranspaymentinfoComponent, { size: <any>'l' });
    modalRef.componentInstance.trid = this.trainingid;
    modalRef.componentInstance.formname = this.formname;

    modalRef.componentInstance.transdate = this.trainingBO.startdt;
    modalRef.componentInstance.transpaymodeid = this.trainingBO.transpaymodeid;
    modalRef.componentInstance.refno = this.trainingBO.payrefno;
    modalRef.componentInstance.paiddt = this.fnConvertDatetime(this.fnFormatDatetime(this.trainingBO.paiddt));
    modalRef.componentInstance.paymentinfo = this.trainingBO.paymentinfo;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === "DONE") {
        this.fngetTraining();
      }

    });

  }
  public fnRemovePayment() {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to Remove Payment?')
        .then((confirmed) => {
          if (confirmed) {
           this.fnSetRemovePayment()
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  private fnSetRemovePayment() {
    var data = {
      'trxid': this.trainingid,
      'formname': this.formname,
      'modifiedby': this.loginService.fnGetModUserId(),
    }
    this.appService.fnSetRemovePayment(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The Payment has been Removed successfully.");
            //this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetTraining();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //#Attachment
  fnAttachmentBtnClick() {

    const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.trainingid;
    modalRef.componentInstance.formmode = "EDIT";
    modalRef.componentInstance.fnGetAttachment();

    modalRef.result.then(() => {
      this.fnGetAttachmentCount()
    }, () => {
      this.fnGetAttachmentCount()
    })


    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
      if (receivedEntry === 'DONE') {
        this.fngetTraining();
      }
    });

  }


  fnAttachmentSave(tid) {



  }

  fnSetAttachmentCount(data) {

    this.attachmentcount = data;
  }



  //Attachment
  fnGetAttachmentCount() {
    if (this.trainingid > 0) {
      var data = {
        'trxid': this.trainingid,
        'trxtype': this.formname,
      }


      this.appService.fngetAttachmentCountDetails(data).subscribe(
        (res) => {
          if (res.json().status === 200) {
            var result = res.json().result;
            if (result.length > 0) {
              this.attachmentcount = result[0].attachmentcount
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        });
    }

  }
  fnAddActivity(){

    const modalRef = this.productFindService.open(ActivitypopupComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.trxid = this.trainingid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {      

     
    });

  } 

  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  fnResetSaveFlag() {
    this.submitted = false;
    this.successfully = false;
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}